import React from 'react'
import PropTypes from 'prop-types'

const Show = (props) => props.if ? props.children : <span />
Show.propTypes = {
    if: PropTypes.bool,
    children: PropTypes.node
}

export default Show
